export const HOME_VIEWS = {
  FRANCHISE_MARKETING: "franchise-marketing",
  DEFAULT: "default",
};

export function isFranchiseMarketingProfile(userDetail) {
  const profiles = userDetail.map((perfil) => perfil.TiposPessoa).flat() || [];

  const showSection = profiles.some(
    (perfil) =>
      (perfil || []).includes("FRANQUIA") &&
      !(perfil || []).includes("REPRESENTANTE"),
  );

  return showSection;
}

export function getHomeView(userDetail) {
  if (isFranchiseMarketingProfile(userDetail)) {
    return HOME_VIEWS.FRANCHISE_MARKETING;
  }
  return HOME_VIEWS.DEFAULT;
}
